/* eslint-disable @typescript-eslint/no-explicit-any */
// @ts-nocheck
import React from 'react';

import { DeviceStatus } from './device-status';
import { connect } from 'react-redux';

import { deviceStatusesSelector } from '../../../../selectors/device-status-selector';
import { LedIndicator } from '../../../../components/widgets/led-indicator';
import styled from 'styled-components';
import { Popup } from 'semantic-ui-react';

const Container = styled.section``;

export function $DeviceStatusList(props: any) {
  const { finalStatus, items } = props;
  return (
    <Popup
      on="click"
      trigger={
        <a>
          <LedIndicator severity={finalStatus} />
        </a>
      }
    >
      <Container>
        {items.map((item, i) => (
          <DeviceStatus key={i} {...item} />
        ))}
      </Container>
    </Popup>
  );
}

function mapStateToProperties(state) {
  return deviceStatusesSelector(state);
}

export const DeviceStatusList = connect(mapStateToProperties)($DeviceStatusList);
